"use client";

import { usePathname } from "next/navigation";
import { useEffect, useRef } from "react";

import { routes } from "#/config/routes";
import { useSearchParam } from "#/hooks/useSearchParam";
import { TradePanelTab } from "#/types/tradePanel";

import { useMarket } from "../app/portfolio/market";
import { useShowTradePanel } from "../app/tradePanel/showTradePanel";
import { useTradePanelTab } from "../app/tradePanel/tradePanelTab";
import { useMaturity } from "./page/maturity";
import { useOptionchain } from "./page/optionchain";

export const OptionsUpdater = () => {
  const { maturity } = useMaturity();
  const { market } = useMarket();
  const { setShowTradePanel } = useShowTradePanel();
  const { setTradePanelTab } = useTradePanelTab();
  const pathname = usePathname();
  const panelTab = useSearchParam<TradePanelTab>("panelTab");

  const { setOptionchain } = useOptionchain();

  const previousMarketMaturity = useRef({ market, maturity });

  const isOptionsPage = pathname === routes.options();

  useEffect(() => {
    if (!isOptionsPage) return;

    if (panelTab) {
      setShowTradePanel(true);
      setTradePanelTab(panelTab);
      return;
    }

    setTradePanelTab("options");
  }, [isOptionsPage, panelTab, setShowTradePanel, setTradePanelTab]);

  // Reset optionchain when market or maturity changes so we can have loading state on the optionchain
  useEffect(() => {
    const hasMarketChanged = previousMarketMaturity.current.market !== market;
    const hasMaturityChanged =
      previousMarketMaturity.current.maturity !== maturity;

    if (hasMarketChanged || hasMaturityChanged) {
      setOptionchain([]);
      previousMarketMaturity.current = { market, maturity };
    }
  }, [market, maturity, setOptionchain]);

  return null;
};
